const Url = {
  // apiUrl: "http://172.16.18.114:1111/api/",
  apiUrl: "https://api.yingkesuzhou.yingkelawyer.com/api/",
  imgUrl: "",
};

export default Url;
